import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import CategoryPiratesQuoteAndAttribution from 'src/app/organisms/Homepage/CategoryPiratesQuoteAndAttribution/CategoryPiratesQuoteAndAttribution';

const CategoryPiratesTestimonial = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-none']}
      paddingSm={['spacing-4xl', 'spacing-none']}
    >
      <Stack
        justify='center'
        padding={['spacing-none', 'spacing-4xl']}
        paddingSm={['spacing-none', 'spacing-xl']}
      >
        <CategoryPiratesQuoteAndAttribution />
      </Stack>
    </SectionLayout>
  );
};

export default CategoryPiratesTestimonial;
